import { API_ENDPOINTS } from '@/constants';
import { apiClient } from '@/services/api';
import type { SetupStatusResponse } from '@/types';

// No toast: Setup keeps its plain grid when the status fails, and with the query retries
// one failure would toast three times.
export const fetchSetupStatus = async (): Promise<SetupStatusResponse> => {
  const response = await apiClient.get<SetupStatusResponse>(API_ENDPOINTS.SETUP_STATUS, {
    headers: { 'X-Skip-Error-Message': 'true' },
  });
  return response.data;
};
